import React from "react";
import { motion } from "framer-motion";

/**
 * A reusable loading spinner component with centered text
 * @param {Object} props - Component props
 * @param {string} props.text - Loading text to display
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.style - Additional inline styles
 * @returns {JSX.Element} - Loading spinner component
 */
const LoadingSpinner = ({
  text = "Loading...",
  className = "",
  style = {},
}) => {
  return (
    <motion.div
      className={`loading-container ${className}`}
      style={style}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.1 }}
    >
      <motion.div
        className="loading-spinner"
        animate={{ rotate: 360 }}
        transition={{
          duration: 0.6,
          repeat: Infinity,
          ease: "linear",
        }}
      />
      <motion.p
        className="loading-text"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.05 }}
      >
        {text}
      </motion.p>
    </motion.div>
  );
};

export default LoadingSpinner;
